import React, { PropsWithChildren } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import {
  FartherTable,
  FartherTableBody,
  FartherTableBodyCell,
  FartherTableContainer,
  FartherTableHead,
  FartherTableHeaderCell,
  FartherTablePagination,
  FartherTableSortLabel,
} from "./Components";
import TableRow from "./TableRow/TableRow";

import * as componentStyles from "./Components.module.css";

interface Props<Keys extends string> {
  columns: NonEmptyArray<Keys>;
  emptyRows?: number;
  emptyCell?: React.ReactNode;
  hidePaginationKeepFooter?: boolean;
  noBorderRadius: boolean;
}

const EmptyTable = <Keys extends string>(
  props: PropsWithChildren<Props<Keys>>
) => {
  return (
    <FartherTableContainer
      className={toClassName(componentStyles.tableContainerClassName, {
        [componentStyles.noBorderRadius]: props.noBorderRadius,
        [componentStyles.emptyTable]: true,
      })}
    >
      <div style={{ position: "relative" }}>
        <FartherTable>
          <FartherTableHead className={componentStyles.headerClassName}>
            {props.columns.map((h) => (
              <FartherTableHeaderCell key={h}>
                <FartherTableSortLabel disabled={true}>
                  {h}
                </FartherTableSortLabel>
              </FartherTableHeaderCell>
            ))}
          </FartherTableHead>

          <FartherTableBody>
            {Array.from({ length: props.emptyRows ?? 0 }).map((_, idx) => (
              <TableRow key={idx} className={componentStyles.emptyRow}>
                {() =>
                  props.columns.map((h) => (
                    <FartherTableBodyCell key={h}>
                      <span style={{ visibility: "hidden" }}>
                        {props.emptyCell}
                      </span>
                    </FartherTableBodyCell>
                  ))
                }
              </TableRow>
            ))}
          </FartherTableBody>
        </FartherTable>
        <div className={componentStyles.emptyContainer}>{props.children}</div>
        <FartherTablePagination
          pageSize={0}
          currentPage={0}
          totalCount={0}
          onPageChange={() => {}}
          isNextButtonDisabled={true}
          isPrevButtonDisabled={true}
          hidePaginationKeepFooter={props.hidePaginationKeepFooter}
        />
      </div>
    </FartherTableContainer>
  );
};

export default EmptyTable;
